import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { MessageService } from 'src/app/core/services/message.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, catchError, Observable } from 'rxjs';

import { PageDonnee } from 'src/app/shared/interfaces/page-donnee';

@Injectable({
  providedIn: 'root'
})
export class CommandeService {

  constructor(
    private messageService: MessageService
    ,private http: HttpClient
    ) { }

  private donneesSubject = new BehaviorSubject<any[]>([]);
  public donnees$ = this.donneesSubject.asObservable();

  private chargementSubject = new BehaviorSubject<boolean>(false);
  public chargement$ = this.chargementSubject.asObservable();

  private indexPageSubject = new BehaviorSubject<number>(0);
  public indexPage$ = this.indexPageSubject.asObservable();

  private taillePageSubject = new BehaviorSubject<number>(10);
  public taillePage$ = this.taillePageSubject.asObservable();

  private totalElementsDonneesSubject = new BehaviorSubject<number>(0);
  public totalElementsDonnees$ = this.totalElementsDonneesSubject.asObservable();


    lieuDepartTexte?:string;

    expLocGps?:string;

    lieuArriveeTexte?:string;

    desLocGps?:string;

    articlesPanier : any = [];

  arrondiMontant(montant: number): number{
    const montantDiviseParCinq: number = montant / 5;
    return (Math.ceil(montantDiviseParCinq) * 5);
  }

  enregistrerExpediteur(expediteur: any): Observable<any> {
    const url = `${environment.apiurl}` + 'expediteurs';
    return this.http.post<any>(url, expediteur).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  enregistrerDestinataire(destinataire: any): Observable<any> {
    const url = `${environment.apiurl}` + 'destinataires';
    return this.http.post<any>(url, destinataire).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  modifierExpediteur(expediteur: any): Observable<any> {
    const url = `${environment.apiurl}` + 'expediteurs/' + expediteur.id;
    const { id, ...donneesExpediteur } = expediteur;
    return this.http.patch<any>(url, donneesExpediteur).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  modifierDestinataire(destinataire: any): Observable<any> {
    const url = `${environment.apiurl}` + 'destinataires/' + destinataire.id;
    const { id, ...donneesDestinataire } = destinataire;
    return this.http.patch<any>(url, donneesDestinataire).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirURLContactsUtilisateur(typeContact: string, idUtilisateur: number) {
    let typeContactURL = '';
    if(typeContact == 'Expéditeur') {
      typeContactURL = 'expediteurs/user/' + idUtilisateur;
    } else {
      typeContactURL = 'destinataires/user/' + idUtilisateur;
    }
    const url = `${environment.apiurl}` + typeContactURL;
    return url;
  }

  enregistrerArticle(article: any): Observable<any> {
    const url = `${environment.apiurl}` + 'articles';
    return this.http.post<any>(url, article).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  calculerPrixUnitaire(article: any): Observable<any> {
    const url = `${environment.apiurl}` + 'articles/calculerPrixUnitaire';
    return this.http.post<any>(url, article).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  supprimerCommande(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiurl}commandes/supprimerCommande/${id}`).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  enregistrerCommande(commande: any): Observable<any> {
    if (commande.dateEnlevementPrev != null && commande.dateEnlevementPrev != undefined) {
      commande = this.formaterDateCommande(commande);
    }

    delete commande.heureEnlevementPrev;
    delete commande.expediteurid;
    delete commande.destinataireid;

    const url = `${environment.apiurl}` + 'commandes/enregistrerCommande';
    return this.http.post<any>(url, commande).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  formaterDateCommande(commande: any) : any {
      const valeurDate = commande.dateEnlevementPrev;
      const date = valeurDate instanceof Date ? valeurDate : new Date(valeurDate);
      if (Number.isNaN(date.getTime())) {
        return commande;
      }

      const heure: string = commande.heureEnlevementPrev ?? '00:00';
      const [hhRaw, minRaw] = (typeof heure === 'string' ? heure : '00:00').split(':');
      const hh = (hhRaw ?? '00').padStart(2, '0');
      const min = (minRaw ?? '00').padStart(2, '0');

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      commande.dateEnlevementPrev = `${yyyy}-${mm}-${dd}T${hh}:${min}:00`;

      return commande;
  }

  obtenirCommandes(page: number, taille: number, statut?: string, sansLivreur?: boolean) {
    const url = `${environment.apiurl}` + 'commandes';
    const params: any = { page, size: taille };
    if (statut && statut !== 'all' && statut !== 'SANS_LIVREUR') {
      params['statut'] = statut;
    }
    if (statut === 'SANS_LIVREUR' || sansLivreur) {
      params['sansLivreur'] = true;
    }
    this.chargementSubject.next(true);
    this.http.get<PageDonnee<any>>(url, { params })
    .subscribe(
      donnees => {
        this.donneesSubject.next(donnees.content);
        this.chargementSubject.next(false);
        this.indexPageSubject.next(donnees!.page);
        this.totalElementsDonneesSubject.next(donnees!.totalElements);
      },
      erreur => {
        console.error('Erreur lors de la récupération des commandes', erreur);
        this.chargementSubject.next(false);
      }
    );
  }

  /** Compteurs globaux pour les pastilles /dashboard et /commande/lister (même source que le backend). */
  obtenirCompteursListe(): Observable<Record<string, number>> {
    const url = `${environment.apiurl}commandes/compteurs-liste`;
    return this.http.get<Record<string, number>>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirCommande(id: number): Observable<any> {
    const url = `${environment.apiurl}commandes/${id}`;
    return this.http.get<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  definirCommandesLivreesNeuves(donnees:any) {
    this.donneesSubject.next(donnees!.list);
    this.chargementSubject.next(false);
    this.indexPageSubject.next(0);
    this.totalElementsDonneesSubject.next(1);
  }

  obtenirCommandesDuLivreur(idLivreur: number): Observable<any> {
    const url = `${environment.apiurl}commandes/livreur/${idLivreur}`;
    return this.http.get<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirHistoriqueLivreur(
    idLivreur: number,
    page: number,
    taille: number,
    statut?: string,
    dateDebut?: string,
    dateFin?: string
  ): Observable<any> {
    const url = `${environment.apiurl}commandes/livreur/${idLivreur}/historique`;
    const params: Record<string, string> = {
      page: String(page),
      size: String(taille)
    };
    if (statut && statut !== 'ALL') {
      params['statut'] = statut;
    }
    if (dateDebut) {
      params['dateDebut'] = dateDebut;
    }
    if (dateFin) {
      params['dateFin'] = dateFin;
    }
    return this.http.get<any>(url, { params }).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  mettreAJourArticlesCommande(commandeId: number, articles: any[]): Observable<any> {
    return this.http.put<any>(`${environment.apiurl}commandes/${commandeId}/articles`, articles).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  mettreAJourStatutCommande(idCommande: number, statut: string): Observable<any> {
    const url = `${environment.apiurl}commandes/${idCommande}/statut?statut=${statut}`;
    return this.http.put<any>(url, null).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  /** Dernière position GPS connue du livreur pour une commande (cache 10 min). */
  obtenirPositionLivreur(commandeId: number): Observable<{ latitude: number; longitude: number }> {
    return this.http.get<{ latitude: number; longitude: number }>(`${environment.apiurl}commandes/${commandeId}/position-livreur`).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  /** Liste des incidents / réclamations d'une commande. */
  obtenirIncidentsParCommande(commandeId: number): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiurl}incidents/commande/${commandeId}`).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  /** Suivi sans connexion (endpoint public API). */
  suivreCommandeParNumero(numero: string): Observable<any> {
    const url = `${environment.apiurl}commandes/search/suivi/${encodeURIComponent(numero.trim())}`;
    return this.http.get<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  listerEvaluationsClients(page: number, taille: number): Observable<PageDonnee<any>> {
    const url = `${environment.apiurl}commandes/evaluations`;
    return this.http.get<PageDonnee<any>>(url, {
      params: { page: String(page), size: String(taille) }
    }).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirMesEvaluationsLivreur(): Observable<any> {
    const url = `${environment.apiurl}commandes/evaluations/livreur/moi`;
    return this.http.get<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  /** Commandes interurbaines paginées (optionnel: filtre par zoneId). */
  obtenirCommandesInterurbaines(page: number, taille: number, zoneId?: number): Observable<PageDonnee<any>> {
    const params: any = { page: String(page), size: String(taille) };
    if (zoneId) params['zoneId'] = String(zoneId);
    return this.http.get<PageDonnee<any>>(`${environment.apiurl}commandes/interurbain`, { params }).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  /** Intentions clients : commandes interurbaines en attente pour une zone.
   *  zoneId est optionnel : le backend auto-détecte la zone pour RESPONSABLE_ZONE. */
  obtenirIntentionsClients(zoneId?: number): Observable<any[]> {
    const params: any = {};
    if (zoneId) params['zoneId'] = String(zoneId);
    return this.http.get<any[]>(`${environment.apiurl}commandes/interurbain/intentions`, { params })
      .pipe(catchError(this.messageService.gererErreur));
  }

  obtenirCommandesParClient(clientId: number, page = 0, taille = 50): Observable<PageDonnee<any>> {
    return this.http.get<PageDonnee<any>>(`${environment.apiurl}commandes/client/${clientId}`, {
      params: { page: String(page), size: String(taille) }
    }).pipe(catchError(this.messageService.gererErreur));
  }

  uploadPhotoProcess(commandeId: number, etape: 'RECUPERATION' | 'EXPEDITION_CENTRE' | 'RECEPTION_CENTRE' | 'LIVRAISON', file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.put<any>(`${environment.apiurl}commandes/${commandeId}/photos-process/upload?etape=${etape}`, formData).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

}
